import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import { GoSortAsc } from 'react-icons/go';
import { HiCheck } from 'react-icons/hi2';
import { PiSortAscending } from 'react-icons/pi';

import {
    Add,
    Additem,
    Arrow3,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    Calendar,
    Call,
    Clock,
    Colorfilter,
    Danger,
    DocumentDownload,
    Edit,
    Eye,
    EyeSlash,
    Filter,
    Home,
    More,
    Note,
    Repeat,
    SearchNormal,
    Setting,
    Shop,
    Specs,
    Status,
    Trash,
    User,
    Gallery,
    Company,
    Sms,
    Category,
    MessageQuestion,
    TickSquare,
    AddSquare,
    Earth,
    Briefcase,
    Lock,
    Car,
    Tag,
    DollarCircle,
    MinusSquare,
    ShoppingCart,
    ClipboardText,
    Box,
    Logout,
    Checkbox,
    Refresh,
    ArrowRight2,
    ArrowLeft2,
    Sun,
    Moon,
    KeyboardOpen,
    Archive,
    MessageText,
    GalleryAdd,
    Close,
    Dropdown2,
    Printer,
    TaskSquare,
    Next,
    Document,
    Users,
    CloseSquare,
    ArrowCircleRight,
    FlashCircle,
    Flash,
    Brush,
    CopySuccess,
    Code,
    Speedometer,
    Pharagraphspacing,
    ArrowCircleDown,
    People,
    UserRemove,
    UserTick,
    LampSlash,
    NoteAdd,
    CalendarSearch,
    ArrowHorizontal,
    Menu,
    Grid,
    ChangeLock,
    ProfileCircle,
    Wallet,
    Location,
    SupportMessage,
    Card,
    NotificationStatus,
    Personalcard,
    Map,
    LocationAdd,
    ClipboardClose,
    Chart,
    TickCircle,
    GalleryEdit,
    Send
} from '@/assets/icons/outline';
import {
    Add2,
    AddSquare2,
    ArrowSquareDown,
    ArrowSquareRight,
    Car2,
    Danger2,
    Notification2,
    RecordCircle2,
    Setting2,
    StarFilled,
    Task,
    UsersSolid,
    Clock2,
    Circle,
    Grid2,
} from '@/assets/icons/solid';

const appIcons = {
    outline: {
        addItem: Additem,
        filter: Filter,
        add: Add,
        downloadDocument: DocumentDownload,
        sort: Arrow3,
        search: SearchNormal,
        dots: More,
        leftArrow: ArrowLeft,
        rightArrow: ArrowRight,
        downArrow: ArrowDown,
        clock: Clock,
        setting: Setting,
        warning: Danger,
        marketPlace: Shop,
        status: Status,
        edit: Edit,
        eyeSplash: EyeSlash,
        eye: Eye,
        user: User,
        group: Colorfilter,
        details: Note,
        specs: Specs,
        calendar: Calendar,
        trash: Trash,
        replace: Repeat,
        home: Home,
        call: Call,
        close: Close,
        dropdown: Dropdown2,
        image: Gallery,
        category: Category,
        question: MessageQuestion,
        resolve: TickSquare,
        addSquare: AddSquare,
        company: Company,
        email: Sms,
        country: Earth,
        business: Briefcase,
        password: Lock,
        car: Car,
        tag: Tag,
        dollarCircle: DollarCircle,
        minusSquare: MinusSquare,
        shoppingCart: ShoppingCart,
        clipboardText: ClipboardText,
        box: Box,
        logout: Logout,
        checkbox: Checkbox,
        refresh: Refresh,
        loading: AiOutlineLoading3Quarters,
        sortAsc: GoSortAsc,
        sortDes: PiSortAscending,
        arrowRight: ArrowRight2,
        arrowLeft: ArrowLeft2,
        sun: Sun,
        moon: Moon,
        system: KeyboardOpen,
        flashCircle: FlashCircle,
        document: Document,
        archive: Archive,
        textMessage: MessageText,
        addImage: GalleryAdd,
        closeSquare: CloseSquare,
        arrowCircleRight: ArrowCircleRight,
        arrowCircleDown: ArrowCircleDown,
        print: Printer,
        tickSquare: TickSquare,
        printer: Printer,
        taskSquare: TaskSquare,
        next: Next,
        users: Users,
        flash: Flash,
        brush: Brush,
        copySuccess: CopySuccess,
        code: Code,
        speedometer: Speedometer,
        paragraphSpacing: Pharagraphspacing,
        people: People,
        deactivateUser: UserRemove,
        activateUser: UserTick,
        lampSlash: LampSlash,
        reschedule: NoteAdd,
        calendarSearch: CalendarSearch,
        arrowHorizontal: ArrowHorizontal,
        menu: Menu,
        grid: Grid,
        check: HiCheck,
        changeLock: ChangeLock,
        profileCircle: ProfileCircle,
        location: Location,
        wallet: Wallet,
        supportMessage: SupportMessage,
        card: Card,
        map: Map,
        notificationStatus: NotificationStatus,
        personalcard: Personalcard,
        locationAdd: LocationAdd,
        clipboardClose: ClipboardClose,
        chart: Chart,
        tickCircle: TickCircle,
        galleryEdit: GalleryEdit,
        send: Send
    },

    solid: {
        car: Car2,
        setting: Setting2,
        add: Add2,
        notification: Notification2,
        dot: RecordCircle2,
        plusSquare: AddSquare2,
        star: StarFilled,
        warning: Danger2,
        check: FaCheck,
        Inspection: Task,
        users: UsersSolid,
        arrowSquareDown: ArrowSquareDown,
        arrowSquareRight: ArrowSquareRight,
        clock: Clock2,
        circle: Circle,
        grid: Grid2,
    },
};

export default appIcons;
